export function setToLocal (name, payload) {
  window.localStorage.setItem(name, JSON.stringify(payload))
}

export function getFromLocal (name) {
  const item = window.localStorage.getItem(name) ||
    window.sessionStorage.getItem(name)

  return JSON.parse(item)
}

export function deleteFromLocal (name) {
  window.localStorage.removeItem(name)
  window.sessionStorage.removeItem(name)
}

export function setLocale (locale) {
  window.localStorage.setItem(`hdyra-v-${process.env.NODE_ENV[0]}-locale`, locale)
}

export function getLocale () {
  return window.localStorage.getItem(`hydra-v-${String(process.env.VUE_APP_COMPANY).snakeCase()}-${process.env.NODE_ENV[0]}-locale`)
}

export function getDaysAgo(days){
  let date = new Date;
  date.setDate( date.getDate() - days );
  return date
}

export function formatDate(date) {
  let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

  if (month.length < 2) 
      month = '0' + month;
  if (day.length < 2) 
      day = '0' + day;

  return [year, month, day].join('-');
}

export function uuidv4() {
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  );
}
